var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCertifiedBadge = function SvgCertifiedBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 3h6v6H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.114 5.245a1.332 1.332 0 0 1-.757-1.828c.538-1.132-.643-2.313-1.775-1.774A1.332 1.332 0 0 1 7.755.886c-.42-1.181-2.09-1.181-2.51 0a1.332 1.332 0 0 1-1.828.757c-1.132-.539-2.313.642-1.774 1.774a1.332 1.332 0 0 1-.757 1.828c-1.181.42-1.181 2.09 0 2.51a1.332 1.332 0 0 1 .757 1.827c-.539 1.132.642 2.313 1.774 1.775a1.332 1.332 0 0 1 1.828.757c.42 1.18 2.09 1.18 2.51 0a1.332 1.332 0 0 1 1.827-.757c1.132.538 2.313-.643 1.775-1.775a1.332 1.332 0 0 1 .757-1.827c1.18-.42 1.18-2.09 0-2.51Zm-3.132-.518C8.26 5.812 7.537 6.895 6.814 7.98c-.146.22-.3.435-.431.663-.169.294-.568.3-.776.084-.49-.508-1.003-.992-1.506-1.486-.18-.177-.198-.356-.128-.54a.456.456 0 0 1 .483-.272c.104.019.213.087.292.163.37.357.73.724 1.11 1.104.211-.315.41-.61.608-.908.576-.86 1.15-1.723 1.726-2.584.127-.189.403-.319.657-.137.219.158.284.433.133.66Z",
    fill: "#FFA756"
  })));
};

export default SvgCertifiedBadge;